/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Empty
 *
 * 1 = Active
 *
 * 2 = LostSales
 *
 * 3 = FutureProspecting
 *
 * 4 = Dealt
 *
 * 5 = Call
 *
 * 6 = Invalid
 *
 * 7 = HotLead
 *
 * 8 = Appointed
 *
 * 9 = ColdLead
 *
 * 10 = Dublicate
 *
 * 11 = Assigned
 *
 * 12 = Invoiced
 */
export enum LeadStatusEnum {
  Empty = 0,
  Active = 1,
  LostSales = 2,
  FutureProspecting = 3,
  Dealt = 4,
  Call = 5,
  Invalid = 6,
  HotLead = 7,
  Appointed = 8,
  ColdLead = 9,
  Dublicate = 10,
  Assigned = 11,
  Invoiced = 12,
}
